import { AxiosInstance } from "axios";
import { useState, useEffect } from "react";
import { Predicates } from "../libraries/predicates/predicates";
import { ITCCReason } from "../types/data.interface";
import { PageableDTO } from "../types/pageable";
import useAxios from "../utils/useAxios";

type SearchParams = {};

type TCCReasonResponse = PageableDTO<ITCCReason[]> | ITCCReason[];

export const fetchTCCReason = async ({
  axios,
}: SearchParams & { axios: AxiosInstance }) => {
  try {
    const response = await axios.get<TCCReasonResponse>(`/tcc-reasons/`);

    return Predicates.parsePageableReponseToType(response);
  } catch (err) {
    console.error(err);
  }
  return [];
};

export default function useTccReason({}: SearchParams) {
  const axios = useAxios();
  const [data, setData] = useState<ITCCReason[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      const response = await fetchTCCReason({
        axios,
      });

      setData(response);
      setIsLoading(false);
    };

    getData();
  }, []);

  return { data, isLoading };
}
